import { useTranslation } from "react-i18next";
import { enTranslation } from "../../translation/en/global";

const AppCard = ({ feature }) => {
  return (
    <div className="bg-[#c7d2fe] rounded-[1.5rem]  !p-10 h-full shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.06)] transition-all duration-300 ease-in-out mx-auto w-full flex flex-col hover:-translate-y-1 hover:shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)]">
      <div className="">
        <h3 className="text-[20px] md:text-[30px] font-medium">{feature.title}</h3>
      </div>

      {/* Content */}
      <div className="w-full text-[12px] md:text-[16px]">
        <p>{feature.description}</p>
      </div>
    </div>
  );
};

const Tesitudefeature = () => {
  const { t } = useTranslation();
  const features = enTranslation.testitude.features.items;

  return (
    <div className="h-[100%] w-[100%] md:!px-[5rem] px-[1rem] text-[#313F78]">
      {/* overview and mission  */}
      <div className="flex flex-col gap-10 !px-5 md:!px-28">
        <div className="flex flex-col md:flex-row text-center md:text-left">
          <div className="md:basis-1/3">
            <h2 className="text-[20px] md:text-[30px] font-semibold">
              {t("testitude.overview.title")}
            </h2>
          </div>
          <div className="md:basis-2/3">
            <h3 className="text-[14px] md:text-[22px] font-medium !mb-2">
              {t("testitude.overview.subtitle")}
            </h3>
            <p className="text-[12px] md:text-[16px] !px-5 md:!px-0 indent-0 text-justify">
              {t("testitude.overview.description")}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row !px-5 md:!px-0 text-center md:text-left">
          <div className="md:basis-1/3">
            <h2 className="text-[20px] md:text-[30px] font-semibold">
              {t("testitude.vision.title")}
            </h2>
          </div>
          <div className="md:basis-2/3">
            <h3 className="text-[14px] md:text-[22px] font-medium !mb-2">
              {t("testitude.vision.subtitle")}
            </h3>
            <p className="text-[12px] md:text-[16px] indent-0 text-justify">
              {t("testitude.vision.description")}
            </p>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div className="cards-section">
        <h1 className="cards-title md:!mt-10 !font-normal">{t("testitude.features.title")}</h1>
        <div className="cards-grid">
          {Object.entries(features).map(([key, feature]) => (
            <div key={key} className="card-wrapper">
              <AppCard feature={feature} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tesitudefeature;
